import { fetchRegionalUserProfileInfo } from "../backend/pdxBackendClient";

/**
 * Reads the latest profile-metadata timestamp through the protected regional
 * backend without downloading the full JSON profile payload.
 *
 * @param {string} uid - Firebase UID kept for call-site compatibility.
 * @returns {Promise<{ latestMs: number | null, newestName: string | null } | null>}
 * Latest profile summary or null when absent.
 */
export async function fetchLatestMetadataInfo(uid) {
  if (!uid) {
    return null;
  }

  const response = await fetchRegionalUserProfileInfo();

  return {
    latestMs: response?.latestMs ?? null,
    newestName: response?.newestName ?? null,
  };
}
